import React from 'react';

import { createStyles, withStyles, WithStyles } from '@material-ui/core';
import classnames from 'classnames';

import FabLumaBot, { FabLumaBotProps } from './FabLumaBot';

const styles = createStyles({
  root: {
    position: 'absolute',
    right: 20,
    bottom: 20,
  },
});

export interface WidgetLumaBotFabProps extends Omit<FabLumaBotProps, 'classes'>, WithStyles<typeof styles> {}

const WidgetLumaBotFab: React.FC<WidgetLumaBotFabProps> = ({ classes, className, ...rest }) => (
  <div className={classnames(classes.root, className)}>
    <FabLumaBot {...rest} />
  </div>
);

export default withStyles(styles, { name: 'WidgetLumaBotFab' })(WidgetLumaBotFab);
